import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
} from "reactstrap";

const OtherOptionsButton = ({ options, onclick, t }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <li className="list-inline-item">
        <Dropdown
          isOpen={isOpen}
          toggle={() => setIsOpen(!isOpen)}
          className="showbtn moreOptions"
        >
          <DropdownToggle
            className="btn nav-btn nav-btn-light-sec"
            tag="i"
            id="moreOptionsButton"
          >
            <i className="bx bx-dots-horizontal-rounded"></i>
          </DropdownToggle>
          <DropdownMenu
            right
            className="mt-2"
            onMouseLeave={() => setIsOpen(!isOpen)}
          >
            {options &&
              options.options &&
              options.options.map(
                (op, key) =>
                  !op.isHidden && (
                    <DropdownItem
                      key={key}
                      className="d-flex align-items-center justify-content-between py-1"
                      onClick={() => {
                        onclick(op.value);
                      }}
                    >
                      <label className="moreOpDesc my-0 py-1">
                        {t(op.text)}
                      </label>
                      <label className="moreOpShort ml-4 my-0 py-1 text-right">
                        {op.shortcut}
                      </label>
                    </DropdownItem>
                  )
              )}
          </DropdownMenu>
        </Dropdown>
      </li>
      <UncontrolledTooltip
        placement="bottom"
        target="moreOptionsButton"
        className="uncontrolledTooltip"
      >
        {t("Conversation options")}
      </UncontrolledTooltip>
    </>
  );
};

export default withTranslation()(OtherOptionsButton);
